import { getAppVersion } from "~/utils/version";
import { SidebarMenu, SidebarMenuItem } from "~/components/ui/sidebar";

export function AppVersion() {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <div className="flex items-center justify-center px-2 py-1">
          <span className="text-xs" style={{ color: "#8a8a95" }}>
            Version {getAppVersion()}
          </span>
        </div>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
